import React, { useMemo, useState } from "react";
import "./styles.css";
import FloatingContainer from "../FloatingContainer";
import Button from "../Button";
import Slider from "../Slider";

const SimMenu = ({
  onUpdateRates,
  rate,
  onTemperatureSet,
  onStartSim,
  onStopSim,
  onMolRotationSetByValue,
  onMolRotationChange,
  isSimOn,
  engine,
  onWritePDB,
  onClose,
  temperature,
  maxTemperature,
  ...props
}) => {
  const handleUpdateRatesUp = () => {
    onUpdateRates("up");
  };
  const handleUpdateRatesDown = () => {
    onUpdateRates("down");
  };

  const step = useMemo(() => {
    return maxTemperature / 20;
  }, [maxTemperature]);

  const handleSim = () => {
    if (isSimOn) {
      onStopSim();
    } else {
      onStartSim();
    }
  };

  const handleMolRotationSet = () => {
    let RotationsObject = {
        rotX: 0,
        rotY: 1.57,
        rotZ: 0
    };
    onMolRotationSetByValue(RotationsObject);
    console.log(RotationsObject)
  };

  const handleMolRotationChange = () => {
    let RotationsObject = {
        rotX: 0,
        rotY: 0.8,
        rotZ: 0
    };
    onMolRotationChange(RotationsObject);
    console.log(RotationsObject)
  };

  return (
    <FloatingContainer offset="sim" onClose={onClose} className="sim-menu" {...props}>
      <div className="column">
        <p className="menu-title">Simulation controls</p>
        <p className="info-modal-text">Control the simulation and its parameters here.</p>
        <div className="menu-box-container margin-btm column">
          <p className="menu-box-title big">Controls</p>
          <Slider
            min={0}
            max={maxTemperature}
            step={step}
            value={temperature}
            onChange={onTemperatureSet}
            label="Temperature"
            unit="K"
            className="margin-top"
          />
          {(engine === "OPENMM" || engine === "CALVADOS") && (
            <>
              <p className="side-menu-section-header">Simulation update rate</p>
              <div className="row rate-controls">
                <Button variant="light" icon="minus" handleClick={handleUpdateRatesDown}></Button>
                <div className="rate-container">
                  <p>{rate}</p>
                </div>
                <Button variant="light" icon="plus" handleClick={handleUpdateRatesUp}></Button>
              </div>
            </>
          )}
          <Button className="submit-btn" variant="small" icon={isSimOn ? "pause" : "play"} handleClick={handleSim}>
            {isSimOn ? "Pause" : "Play"}
          </Button>

        </div>

        <div className="menu-box-container">
          <div className="export-controls">
            <p className="menu-box-title big">Export PDB</p>
            <Button variant="light icon" icon="download" handleClick={onWritePDB}></Button>
          </div>
        </div>
      </div>
      {/*
      <div className="row">
        <Button className="submit-btn" variant="small" handleClick={handleStartSim}>
          Start Sim
        </Button>

        <Button className="submit-btn" variant="small" handleClick={handleStopSim}>
          Stop Sim
        </Button>
      </div> */}
    </FloatingContainer>
  );
};
export default SimMenu;
